var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('toggle',_vm._g(_vm._b({attrs:{"size":"xs","label":_vm.filter.title},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'toggle',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }